module["exports"] = [
  "Pvt Ltd",
  "Group",
  "Ltd",
  "Limited"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nep/company/suffix.js
 ** module id = 863
 ** module chunks = 0
 **/